'use client';

import {
  BottomSheetHandleArea,
  BottomSheetTitle,
  BottomSheetTitleBox,
  BottomSheetTitleContainer,
  Dim,
  DropdownTriggerArrowCloseIconButton,
  DropdownTriggerArrowOpenIconButton,
  DropdownTriggerBox,
  DropdownTriggerInput,
  IcBoldClose,
  IconButton,
  Sheet,
  SheetContent,
  SheetDimMotion,
  SheetMotion,
  SheetPortal,
  SheetTrigger,
} from '@musinsa/mds';
import type { BankServiceDto } from '@musinsa/services-curator';
import { BankSelectList } from './BankSelectList';

interface BankSelectProps {
  banks: BankServiceDto[];
  selectedBank?: string;
  isOpen: boolean;
  error?: boolean;
  onToggle: () => void;
  onClose: () => void;
  onSelect: (bank: string) => void;
  title?: string;
  placeholder?: string;
  className?: string;
}

export const BankSelect = ({
  banks,
  selectedBank,
  isOpen,
  error,
  onToggle,
  onClose,
  onSelect,
  title = '은행 선택',
  placeholder = '은행을 선택해주세요',
  className,
}: BankSelectProps) => {
  const selectedBankData = banks.find((bank) => bank.displayName === selectedBank);

  return (
    <Sheet direction="bottom" open={isOpen}>
      <SheetTrigger asChild>
        <DropdownTriggerBox onClick={onToggle}>
          <DropdownTriggerInput
            error={error}
            value={selectedBankData?.displayName || ''}
            placeholder={placeholder}
          />
          <DropdownTriggerArrowOpenIconButton />
          <DropdownTriggerArrowCloseIconButton />
        </DropdownTriggerBox>
      </SheetTrigger>
      <SheetPortal>
        <SheetContent onPointerDownOutside={onClose}>
          <SheetMotion direction="bottom">
            <BottomSheetTitle>
              <BottomSheetHandleArea />
              <BottomSheetTitleContainer className="px-4 py-2">
                <BottomSheetTitleBox>{title}</BottomSheetTitleBox>
                <IconButton size="size28x28" onClick={onClose}>
                  <IcBoldClose strokeColor="black" />
                </IconButton>
              </BottomSheetTitleContainer>
            </BottomSheetTitle>

            <BankSelectList
              banks={banks}
              selectedBank={selectedBank}
              onSelect={onSelect}
              className={className}
            />
          </SheetMotion>
        </SheetContent>
        <SheetDimMotion>
          <Dim />
        </SheetDimMotion>
      </SheetPortal>
    </Sheet>
  );
};
